import { Link } from 'react-router-dom';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const NoIntegration = () => {
    const { accountId } = useCurrentAccount();

    return (
        <div className="relative flex flex-grow flex-col items-center justify-center gap-6">
            <img
                alt="DonorSearch"
                src="/images/logos/donorsearch.svg"
                className="w-full max-w-48"
            />

            <p className="w-full max-w-prose text-center text-sm">
                Use DonorSearch’s Wealth Screening tool to enrich data for this Contact based on
                their capacity and likelihood to give.
            </p>

            <Link
                className="intercom-target-integrations flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3.5 py-2.5 text-center text-sm font-medium text-gray-900 hover:bg-gray-100 hover:text-gray-900"
                to={`/accounts/${accountId}/settings/integrations`}
            >
                Enable DonorSearch Integration
            </Link>
        </div>
    );
};

export default NoIntegration;
